export enum InternalPermissionType {
  Reports = 'REPORTS',
  LiveEvents = 'LIVE_EVENTS',
}

/** The organizations with access to one item. A row whose last organization is removed disappears from the list. */
export type InternalPermission = {
  /** The item's id, e.g. the report's. */
  id: string
  type: InternalPermissionType
  /** Can hold ids of organizations that no longer exist. */
  organizationIds: string[]
}

export type InternalPermissionChange = {
  type: InternalPermissionType
  itemId: string
  organizationIds: string[]
}

/** The items one organization has access to; a new organization has `permissions: []`. */
export type InternalOrganizationPermissions = {
  id: string
  permissions: { type: InternalPermissionType; itemIds: string[] }[]
}

export type InternalOrganizationAccessChange = {
  organizationId: string
  type: InternalPermissionType
  itemId: string
  granted: boolean
}

export type InternalOrganizationAccessGrantAll = {
  organizationId: string
  type: InternalPermissionType
  itemIds: string[]
}
